import React, { useEffect } from 'react';

import { Popover } from 'antd';

import useFlightGuests from '@components/ui/guest-box/guest-box-flight/useFlightGuests';
import { initialGuestInfo } from '@components/views/flight/constants';
import useFlightSearchBar from '@domain/flight/context/flight';
import { FlightSearchBarActionType } from '@domain/flight/context/flight/actions';

import { Wrapper, Content, Label, Text } from './styled';
import Guests from './guests';

const FlightGuestBox = () => {
  const { dispatch } = useFlightSearchBar();
  const {
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
    removeAdult,
    addAdult,
    removeChild,
    addChild,
    removeInfant,
    addInfant,
    errorMessages,
  } = useFlightGuests(initialGuestInfo);

  useEffect(() => {
    dispatch({
      type: FlightSearchBarActionType.SET_GUESTS,
      payload: {
        numberOfAdultGuests,
        numberOfChildGuests,
        numberOfInfantGuests,
      },
    });
  }, [
    dispatch,
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
  ]);

  return (
    <Wrapper>
      <Popover
        placement='bottomLeft'
        trigger='click'
        content={
          <Guests
            numberOfAdultGuests={numberOfAdultGuests}
            numberOfChildGuests={numberOfChildGuests}
            numberOfInfantGuests={numberOfInfantGuests}
            onRemoveAdult={removeAdult}
            onAddAdult={addAdult}
            onRemoveChild={removeChild}
            onAddChild={addChild}
            onRemoveInfant={removeInfant}
            onAddInfant={addInfant}
            errorMessages={errorMessages}
          />
        }
      >
        <Content>
          <Label>Yolcular</Label>
          <Text>
            {numberOfAdultGuests + numberOfChildGuests + numberOfInfantGuests}{' '}
            Yolcu
          </Text>
        </Content>
      </Popover>
    </Wrapper>
  );
};

export default FlightGuestBox;
